import { Academy as o } from "./academy.js";
import { Bag as r } from "./bag.js";
import { Globe as m } from "./globe.js";
import { GlobeSmall as i } from "./globe-small.js";
import { Section as t } from "./section.js";
import { Topic as p } from "./topic.js";
import { Webinar as f } from "./webinar.js";
import { World as e } from "./world.js";
import { Leaf as a } from "./leaf.js";
import { HandRock as l } from "./hand-rock.js";
import { Airplane as n } from "./airplane.js";
import { Car as c } from "./car.js";
import { Gambling as k } from "./gambling.js";
import { Retail as g } from "./retail.js";
import { FoodAndBeverage as d } from "./food-_-beverage.js";
import { Hotel as s } from "./hotel.js";
import { Hospitality as b } from "./hospitality.js";
import { DownUp as h } from "./down-up.js";
import { Lightning as L } from "./lightning.js";
import { LightningFilled as u } from "./lightning-filled.js";
import { News as N } from "./news.js";
import { Idea as B } from "./idea.js";
import { Discount as G } from "./discount.js";
import { Prize as C } from "./prize.js";
import { Lock as S } from "./lock.js";
import { LockSmall as y } from "./lock-small.js";
import { Unlock as A } from "./unlock.js";
import { Lock5 as D } from "./lock-5.js";
import { Lock4 as F } from "./lock-4.js";
import { Lock3 as H } from "./lock-3.js";
import { Lock2 as P } from "./lock-2.js";
import { Click as R } from "./click.js";
import { Bank as T } from "./bank.js";
import { EmoticonHappy as W } from "./emoticon-happy.js";
import { PieChart as w } from "./pie-chart.js";
import { Diamond as x } from "./diamond.js";
import { Target as E } from "./target.js";
import { Gift as M } from "./gift.js";
import { Antenna as O } from "./antenna.js";
import { GraphDots as U } from "./graph-dots.js";
import { Chip as v } from "./chip.js";
import { Chip2 as z } from "./chip-2.js";
import { PaintRoller as I } from "./paint-roller.js";
import { Number1 as V } from "./number-1.js";
import { Number1Filled as j } from "./number-1-filled.js";
import { Number2 as q } from "./number-2.js";
import { Number2Filled as J } from "./number-2-filled.js";
import { Number3 as K } from "./number-3.js";
import { Number3Filled as Q } from "./number-3-filled.js";
import { Sun as X } from "./sun.js";
import { Blog as Y } from "./blog.js";
import { Book as Z } from "./book.js";
import { CashStack as _ } from "./cash-stack.js";
import { Gym as $ } from "./gym.js";
import { Scalability as oo } from "./scalability.js";
import { Backspace as ro } from "./backspace.js";
import { Tools as mo } from "./tools.js";
import { Hashtag as io } from "./hashtag.js";
import { Gaming as to } from "./gaming.js";
import { RetailOnline as po } from "./retail-online.js";
import { Podcast as fo } from "./podcast.js";
import { DNA as eo } from "./dna.js";
import { Microphone as ao } from "./microphone.js";
import { Weight as lo } from "./weight.js";
import { MarketplaceLaptop as no } from "./marketplace-laptop.js";
import { PaperBag as co } from "./paper-bag.js";
import { OmnichannelExperiences as ko } from "./omnichannel-experiences.js";
const Dr = {
  Academy: o,
  Bag: r,
  Globe: m,
  GlobeSmall: i,
  Section: t,
  Topic: p,
  Webinar: f,
  World: e,
  Leaf: a,
  HandRock: l,
  Airplane: n,
  Car: c,
  Gambling: k,
  Retail: g,
  FoodAndBeverage: d,
  Hotel: s,
  Hospitality: b,
  DownUp: h,
  Lightning: L,
  LightningFilled: u,
  News: N,
  Idea: B,
  Discount: G,
  Prize: C,
  Lock: S,
  LockSmall: y,
  Unlock: A,
  Lock5: D,
  Lock4: F,
  Lock3: H,
  Lock2: P,
  Click: R,
  Bank: T,
  EmoticonHappy: W,
  PieChart: w,
  Diamond: x,
  Target: E,
  Gift: M,
  Antenna: O,
  GraphDots: U,
  Chip: v,
  Chip2: z,
  PaintRoller: I,
  Number1: V,
  Number1Filled: j,
  Number2: q,
  Number2Filled: J,
  Number3: K,
  Number3Filled: Q,
  Sun: X,
  Blog: Y,
  Book: Z,
  CashStack: _,
  Gym: $,
  Scalability: oo,
  Backspace: ro,
  Tools: mo,
  Hashtag: io,
  Gaming: to,
  RetailOnline: po,
  Podcast: fo,
  DNA: eo,
  Microphone: ao,
  Weight: lo,
  MarketplaceLaptop: no,
  PaperBag: co,
  OmnichannelExperiences: ko
};
export {
  Dr as Various
};
